import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TC_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TC_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TC_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TC_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.047 10.032s.886 11.931 4.882 11.931c3.996 0 4.979-11.93 4.979-11.93h-9.861z",
      fill: "#FECA00",
      stroke: "#F7FCFF",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.912 10.622l.146-.165.695.442c.1-.156.28-.229.53-.217l-.254-.386.206-.11.48.579.048.015-.122-.752.242-.028.158.974h.012c.068 0 .144.032.223.084L28.447 10l.242.028-.122.752a2.12 2.12 0 01.047-.015l.48-.579.207.11-.253.386c.25-.012.429.06.53.217l.694-.442.146.165-.762.485c.01.055.016.115.016.18v.113l1.051-.23.078.195-1.13.4v.136l1.071-.087.032.205-1.102.16v.236l1.105.183-.044.203-1.061-.159v2.299h-.163v-2.323l-.71-.106c-.079.562-.169 1.27-.156 1.526.012.253.201.361.334.438.103.059.172.098.097.171-.17.167-.595.327-1.02.327-.426 0-.846-.16-.937-.327-.016-.03-.014-.027 0-.01.067.077.4.457.425-.599a5.785 5.785 0 00-.168-1.503l-.553.083v2.323h-.163v-2.299l-1.06.159-.045-.203 1.105-.183v-.235l-1.102-.16.032-.206 1.07.087v-.136l-1.129-.4.078-.196 1.051.23v-.112c0-.065.005-.125.016-.18l-.762-.485zm1.391 1.651l.01.034-.492.081v-.185l.482.07zm.01-.758a2.126 2.126 0 00-.021.024l-.471-.104v-.148c0-.03 0-.057.003-.084l.49.312zm.313-.31a3.023 3.023 0 00-.16.149l-.58-.37c.08-.142.242-.194.492-.157l.248.378zm1.07.256l.749-.478c-.082-.141-.242-.193-.493-.156l-.347.53c.032.034.062.07.09.104zm.252.097l.558-.355a.985.985 0 01.003.084v.148l-.56.123zm.225.383l.336-.119v.092l-.336.027zm-.26.349l.596-.087v.185l-.595-.098zm-2.092-.468v.092l.336.027-.336-.119z",
      fill: "#CF6900"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.878 15.843s-1.314 2.2-1.314 3.533c0 0 .896.71 2.435.71 1.54 0 2.332-.71 2.332-.71-.433-1.58-1.171-3.533-1.171-3.533h-2.282z",
      fill: "#00A727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.941 15.235a1.097 1.097 0 012.195 0v.75H24.94v-.75z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.52 12.834s1.733.357 1.733.92c0 .563.699.766.87.614.172-.152 1.38-.259 1.38-.993s.1-.934-.193-1.4c-.293-.466-.905-2.042-1.046-1.41-.14.63-.353 1.098-.744.722-.392-.376-.895-1.173-1.072-.723-.176.45.56.903 0 .903-.559 0-.165.03-.165.41 0 .382.067.741-.348.741s-.415.216-.415.216z",
      fill: "#FF927F"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TC_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TC_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TC_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#TC_svg__d)"
    }
  ))))
), h = t;
export {
  h as default
};
